import { useCallback } from "react";
import { useStore } from "@shared/store/useStore";
import { type BoxOfficeConfigType } from "@shared/store/slices/createBoxOfficeConfigSlice";

/**
 * Get the saved options information from the store (if any)
 */
export function useBoxOfficeConfig(): {
  boxOfficeConfig: BoxOfficeConfigType;
  setConfigValue: (value: Partial<BoxOfficeConfigType>) => void;
} {
  const [boxOfficeConfig, setBoxOfficeConfig] = useStore(
    (boxOfficeConfigSlice) => [
      boxOfficeConfigSlice.boxOfficeConfig,
      boxOfficeConfigSlice.setBoxOfficeConfig,
    ]
  );

  const setConfigValue = useCallback(
    (values: Partial<BoxOfficeConfigType>) => {
      const updatedBoxOfficeConfig = { ...boxOfficeConfig, ...values };

      setBoxOfficeConfig(updatedBoxOfficeConfig);
    },
    [setBoxOfficeConfig, boxOfficeConfig]
  );

  return {
    boxOfficeConfig,
    setConfigValue,
  };
}
